<template>
    <Layout>
        <div class="sticky-header">
            <div class="row">
                <div class="col-lg-12 col-sm-12">
                    <h4 class="header-title pb-3">
                        <a @click="$router.push('/')" class="ml-2 cursor-pointer">
                            <i class="fa fa-arrow-left"></i></a>
                        <span class="ml-3">Búsqueda</span>
                    </h4>
                    <div class="card-container m-b-30">
                        <div class="card-body card">
                            <div class="general-label">
                                <!--<div class="form-group">
                                    <label>Búsqueda por NIT</label>
                                    <input type="text" class="form-control" placeholder="Escriba aquí" v-model="searchNit">
                                </div>-->
                                <div class="form-group">
                                    <label>Ingrese información para buscar</label>
                                    <div class="mt-3">
                                        Buscar por: <br>
                                        <select v-model="typesearch" class="form-control">
                                            <option value="dpi" selected>DPI</option>
                                            <option value="nit">NIT</option>
                                            <option value="poliza">Póliza</option>
                                            <option value="requerimiento">Requerimiento</option>
                                        </select>
                                    </div>
                                    <div class="mt-3">
                                        <div v-if="typesearch === 'dpi'">
                                            <span class="mt-1">Ingrese DPI sin guiones ni espacios</span>
                                            <input type="tel" class="form-control" placeholder="Escriba aquí" v-model="searchValue" v-on:keyup.enter="preSearch">
                                        </div>
                                        <div v-if="typesearch === 'poliza'">
                                            <span class="mt-1">Ingrese el producto</span>
                                            <input type="text" class="form-control" placeholder="Escriba aquí" v-model="searchExtraUno">
                                            <span class="mt-1">Ingrese afiliada</span>
                                            <input type="tel" class="form-control" placeholder="Escriba aquí" v-model="searchExtraDos">
                                            <span class="mt-2">Ingrese No.Póliza</span>
                                            <input type="tel" class="form-control" placeholder="Escriba aquí" v-model="searchValue" v-on:keyup.enter="preSearch">
                                        </div>
                                        <div v-if="typesearch === 'requerimiento'">
                                            <span class="mt-1">Ingrese la serie</span>
                                            <input type="text" class="form-control" placeholder="Escriba aquí" v-model="searchExtraUno">
                                            <span class="mt-2">Ingrese No.Requerimiento</span>
                                            <input type="tel" class="form-control" placeholder="Escriba aquí" v-model="searchValue" v-on:keyup.enter="preSearch">
                                        </div>
                                        <div v-if="typesearch === 'nit'">
                                            <span class="mt-1">Ingrese NIT incluyendo el guión</span>
                                            <input type="text" class="form-control" placeholder="Escriba aquí" v-model="searchValue" v-on:keyup.enter="preSearch">
                                        </div>
                                    </div>
                                </div>
                                <!--<h5 class="text-primary">Otros</h5>
                                <div class="form-group">
                                    <label>No.Póliza</label>
                                    <input type="text" class="form-control" placeholder="Escriba aquí">
                                </div>
                                <div class="form-group">
                                    <label>No.Requerimiento</label>
                                    <input type="text" class="form-control" placeholder="Escriba aquí">
                                </div>-->
                                <div class="text-right">
                                    <button @click="preSearch" type="button" class="btn btn-primary btn__buscar" :disabled="buscando">
                                        <span v-if="buscando">Buscando...</span>
                                        <span v-else>Buscar</span>
                                    </button>
                                </div>
                            </div>
                            <div class="searchResultContainer">
                                <div class="searchResult">
                                    <div class="row" v-if="Object.keys(polizas).length > 0">
                                        <template v-if="(typesearch === 'nit' || typesearch === 'dpi')">
                                            <div v-for="poliza in polizas" class="col-12 mb-2 resultItem">
                                                <div class="font-weight-bold">
                                                    {{ poliza.descripcion_producto }}
                                                </div>
                                                <div v-if="poliza.datos_particulares !== '/'" class="font-weight-bold">
                                                    {{ poliza.datos_particulares }}
                                                </div>
                                                <div class="mt-1 text-primary">
                                                    {{ poliza.asegurado }}
                                                </div>
                                                <div class="mt-2 searchResultBadges">
                                                    <div class="row m-0">
                                                        <div class="col-5">
                                                            <div class="miniInfo">
                                                                <span>Póliza:</span>
                                                                <span class="text-secondary">{{ poliza.poliza }}</span>
                                                            </div>
                                                        </div>
                                                        <div class="col-7">
                                                            <div class="miniInfo">
                                                                <span>NIT:</span> {{ poliza.nit }}
                                                            </div>
                                                        </div>
                                                        <div class="col-5">
                                                            <div class="miniInfo">
                                                                <span>Producto:</span> {{ poliza.producto }}
                                                            </div>
                                                        </div>
                                                        <div class="col-7">
                                                            <div class="miniInfo">
                                                                <span>Estado:</span> {{ poliza.estado_poliza }}
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="miniInfo">
                                                                <span>Vigencia:</span> {{ dayjs(poliza.inicio_vigencia).format('DD-MM-YYYY') }} al {{ dayjs(poliza.fin_vigencia).format('DD-MM-YYYY') }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="text-center mt-2">
                                                    <button @click="$router.push('/requerimientos/' + poliza.llave_poliza + '?poliza=' + poliza.poliza)" class="btn btn-primary btn__guardar">
                                                        <i class="fa fa-eye"></i> Requerimientos
                                                    </button>
                                                </div>
                                            </div>
<!--                                            <div class="text-center mt-2">
                                                <button @click="$router.push('/requerimientos/' + item.llave_poliza + '?poliza=' + item.poliza)" class="btn btn-primary">
                                                    <i class="fa fa-eye"></i> Requerimientos
                                                </button>
                                            </div>-->
                                        </template>
                                        <template v-else-if="typesearch === 'requerimiento' || typesearch === 'poliza'">
                                            <div v-for="item in polizas" class="col-12 mb-2 resultItem">
                                                <div class="font-weight-bold">
                                                    Requerimiento No. {{ item.requerimiento }} - {{ item.descripcion_producto }}
                                                    <div v-if="typeof item.indsalteado !== 'undefined'">
                                                        <div v-if="item.indsalteado === 'S'" class="text-danger my-2 text-center">
                                                            Requerimiento Salteado
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-if="item.datos_particulares !== '/'" class="font-weight-bold">
                                                    {{ item.datos_particulares }}
                                                </div>
                                                <div class="mt-1 text-primary">
                                                    {{ item.asegurado }}
                                                </div>
                                                <div class="mt-2 searchResultBadges">
                                                    <div class="row m-0">
                                                        <div class="col-7">
                                                            <div class="miniInfo">
                                                                <span>Monto: </span>
                                                                <span class="font-weight-bold"> {{item.moneda}} {{ Numbro((item.monto) ? item.monto : 0).format({ thousandSeparated: true, mantissa: 2 }) }}</span>
                                                            </div>
                                                        </div>
                                                        <div class="col-5">
                                                            <div class="miniInfo">
                                                                <span>Póliza: </span>
                                                                <span class="text-secondary">{{ item.poliza }}</span>
                                                            </div>
                                                        </div>
                                                        <div class="col-7">
                                                            <div class="miniInfo">
                                                                <span>NIT: </span> {{ item.nit }}
                                                            </div>
                                                        </div>
                                                        <div class="col-5">
                                                            <div class="miniInfo">
                                                                <span>Producto: </span> {{ item.producto }}
                                                            </div>
                                                        </div>
                                                        <div class="col-7">
                                                            <div class="miniInfo">
                                                                <span>Estado: </span> {{ item.estado }}
                                                            </div>
                                                        </div>
                                                        <div class="col-5">
                                                            <div class="miniInfo">
                                                                <span>Pago No. </span> {{item.numero_pago}}
                                                            </div>
                                                        </div>
                                                        <div class="col-12">
                                                            <div class="miniInfo">
                                                                <span>Vigencia: </span> {{ dayjs(item.inicio_vigencia).format('DD-MM-YYYY') }} al {{ dayjs(item.fin_vigencia).format('DD-MM-YYYY') }}
                                                            </div>
                                                        </div>
                                                        <!--<div class="col-12 mt-3">
                                                            <Pago v-if="pagar === item.requerimiento" :reqnumber="item.requerimiento" :requerimiento="item.llave_requerimiento" :monto="parseFloat(item.monto).toFixed(2)" :moneda="item.moneda" :tipo="tipoPago" :poliza="item.poliza" :nombre="nombre" :nit="nit" :direccion="item.direccion" @cancelarPago="cancelarPago" @cancelarPagoRefresh="cancelarPagoRefresh"></Pago>
                                                            <div v-if="pagar !== item.requerimiento" class="text-center mt-2 pagoBtn">
                                                                <button @click="showPago(item, 'tarjeta')" class="btn btn-primary">Tarjeta</button>
                                                                <button @click="showPago(item, 'efectivo')" class="btn btn-success">Efectivo</button>
                                                                <button @click="showPago(item, 'cheque')" class="btn btn-info">Cheque</button>
                                                            </div>
                                                        </div>-->
                                                    </div>
                                                    <div class="mt-4">
                                                        <inicio-pago v-if="typeof item.indprotegido !== 'undefined' && item.indprotegido === 'N'"  typepago="prima" :pago-pendiente="(typeof item.pPnd !== 'undefined') ? item.pPnd : 0" :onlyfact="(typeof item.pLF !== 'undefined') ? item.pLF : 'none'" :pago-log="(typeof item.pL !== 'undefined') ? item.pL : false" :item="item" :pagandoref="pagandoref" @pagandoReferencia="activarPagandoRef"></inicio-pago>
                                                        <div v-else class="text-center font-weight-bold text-danger">
                                                            Requerimiento bloqueado para pago
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                    <div v-if="searched && Object.keys(polizas).length === 0" class="text-center text-muted">
                                        No se encontraron pólizas
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<script>

import Layout from "../../global/components/Layout";
import API from "src/core/Api";
import Tools from "src/core/Tools";
import Numbro from "numbro";
import dayjs from "dayjs";
import {store} from "src/store";
import Pago from "src/modules/pos/views/Pago";
import InicioPago from "src/modules/pos/views/components/InicioPago";

export default {
    props: {},
    components: {
        Pago,
        //TimelineChart,
        Layout,
        //Toster,
        InicioPago,
    },
    data() {
        return {
            Valid: {},
            searchExtraUno: "",
            searchExtraDos: "",
            searchValue: "",
            typesearch: "dpi",
            searched: false,
            polizas: {},

            // PAGO DE REQUERIMIENTO
            pagar: 0,
            tipoPago: '',
            nit: '',
            nombre: '',
            direccion: '',
            polizaNo: '',

            pagandoref: 0,
            pagosToApply: {},
            buscando: false,
        };
    },
    mounted() {
        if (!Tools.tieneParamsBusquedaRuta(this.$route.params)) {
            return;
        }
        this.searchValue = this.$route.params.search;
        this.typesearch = this.$route.params.type;
        this.searchExtraUno = this.$route.params.extra || '';
        this.searchExtraDos = this.$route.params.extrados || '';
        this.search();
    },
    methods: {
        Numbro,
        dayjs,
        search() {

            const self = this;

            if (self.buscando) {
                return;
            }

            let url = '';

            if (self.typesearch === 'dpi') {
                url = 'consulta/dpi?s=' + self.searchValue;
            }
            else if (self.typesearch === 'nit') {
                url = 'consulta/nit?s=' + self.searchValue;
            }
            else if (self.typesearch === 'requerimiento') {
                self.searchExtraUno = self.searchExtraUno.toString().toUpperCase();
                url = 'consulta/req?s=' + self.searchValue + '&serie=' + self.searchExtraUno;
            }
            else if (self.typesearch === 'poliza') {
                self.searchExtraUno = self.searchExtraUno.toString().toUpperCase();
                if (self.searchExtraDos === '') {
                    self.searchExtraDos = 0;
                }
                url = 'consulta/poliza?s=' + self.searchValue + '&producto=' + self.searchExtraUno+ '&afiliada=' + self.searchExtraDos;
            }

            self.buscando = true;

            API.send('GET', url, null,
                function (response) {
                    if (response.status) {
                        self.polizas = (typeof response.data === "object") ? response.data : {};

                        self.searched = true;
                    }
                    else {
                        self.searched = true;
                        alert(response.msg);
                    }
                    self.buscando = false;
                },
                function () {
                    self.searched = true;
                    self.buscando = false;
                    alert('Error de conexión, por favor intente de nuevo');
                },
                {singleFlight: true})
        },
        preSearch() {

            if (this.buscando) {
                return false;
            }

            if (parseInt(this.searchValue) === 0 || Tools.isEmptyString(this.searchValue)) {
                return false;
            }

            if (this.typesearch === 'dpi') {
                this.$router.push({path: '/busqueda/dpi/' + this.searchValue});
            }
            else if (this.typesearch === 'nit') {
                this.$router.push({path: '/busqueda/nit/' + this.searchValue});
            }
            else if (this.typesearch === 'requerimiento') {
                this.$router.push({path: '/busqueda/requerimiento/' + this.searchValue + '/' + this.searchExtraUno});
            }
            else if (this.typesearch === 'poliza') {
                this.$router.push({path: '/busqueda/poliza/' + this.searchValue + '/' + this.searchExtraUno+ '/' + this.searchExtraDos});
                //this.$router.push('/requerimientos/' + this.searchValue + '?nit=' + poliza.nit+ '&nombre=' + poliza.asegurado.trim())
                //this.$router.push({path: '/busqueda/poliza/' + this.searchValue});
            }
            //this.$forceUpdate();
            this.search();
        },
        /*showPago(requerimiento, tipoPago) {
            this.nit = requerimiento.nit;
            this.nombre = requerimiento.asegurado;
            this.direccion = requerimiento.direccion;
            this.pagar = requerimiento.requerimiento;
            this.poliza = requerimiento.poliza;
            this.tipoPago = tipoPago;
        },*/
        activarPagandoRef(data) {
            this.pagandoref = data;
        },
        cancelarPago() {
            this.pagar = 0;
        },
        cancelarPagoRefresh() {
            store.dispatch('coreShowLoading');
            location.reload();
        }
    },
};
</script>
